export function trimValue(value: string): string {
  return value.toLowerCase().replace(/\s+/g, ' ').trim();
}
